<template>
  <div class="address-form">
    <div class="columns">
      <div class="field column">
        <BAutocomplete
          :openOnFocus="true"
          :label="$t('driver_onboarding.profile.address.city')"
          placeholder="VD: Thành phố Hà Nội"
          :data="cityOptions"
          :initValue="city && city.name"
          @onChange="onChangeCity"
        />
      </div>
      <div class="field column">
        <BAutocomplete
          :openOnFocus="true"
          :label="$t('driver_onboarding.profile.address.district')"
          placeholder="VD: Quận Hoàn Kiếm"
          :data="districtOptions"
          :initValue="district && district.name"
          @onChange="onChangeDistrict"
        />
      </div>
    </div>
    <div class="columns">
      <div class="field column">
        <BAutocomplete
          :openOnFocus="true"
          :label="$t('driver_onboarding.profile.address.ward')"
          placeholder="VD: Phường Hàng Buồm"
          :data="wardOptions"          
          :initValue="ward && ward.name"
          @onChange="onChangeWard"
        />
      </div>
      <div class="field column">
        <InputField
          type="text"
          :name="`${fieldName}Detail`"
          :labelName="$t('driver_onboarding.profile.address.detail')"
          :initValue="detail"
          @onChange="onChangeDetail"
        />
      </div>
    </div>
  </div>
</template>
<script>
import InputField from "@/components/InputField";
import BAutocomplete from "@/components/BAutocomplete";
import { mapGetters } from "vuex";

export default {
  data() {
    return {  
      city: null,
      district: null,
      ward: null,
      detail: null
    }
  },
  props: {
    fieldName: {
      type: String,
      requied: true
    },
    requireDetail: {
      type: Boolean
    }
  },
  components: {
    InputField,
    BAutocomplete
  },
  computed: {
    ...mapGetters(["formData", "cityList"]),
    cityOptions () {
      return this.cityList || []
    },
    districtOptions: {
      cache: false,
      get () {
        if (!this.city) return []
        if (!this.cityOptions.length === 0) return []

        const city = this.city
        if (city.name && !city.district) {
          const found = this.cityOptions.find(c => c.name === city.name)
          return found && found.district || []
        }

        return city.district
      }      
    },
    wardOptions: {
      cache: false,
      get () {
        if (!this.district) return []
        if (this.districtOptions.length === 0) return []

        const district = this.district
        if (district.name && !district.ward) {
          const found = this.districtOptions.find(d => d.name === district.name)
          return found && found.ward || []
        }

        return district.ward
      }
    }
  },
  methods: {
    setAddressProfile () {
      const city = this.city && this.city.name
      const district = this.district && this.district.name
      const ward = this.ward && this.ward.name
      const detail = this.detail
      let fullAddress = ''
      if (city && district && ward && (!this.requireDetail || detail)) {
        fullAddress = `${detail}, ${ward}, ${district}, ${city}`
      }

      const { id_address, current_address, family_reg_address } = this.formData
      let formData = {
        id_address,
        current_address,
        family_reg_address
      }
      formData[this.fieldName] = fullAddress
      // console.log('this.fieldName', this.fieldName, fullAddress, formData)
      this.$store.dispatch('setAddressProfile', formData)
    },
    onChangeCity (value) {
      if (this.city && value && this.city.name == value.name)
        return

      this.ward = null
      this.district = null
      this.city = value
      this.setAddressProfile()
    },
    onChangeDistrict (value) {
      if (this.district && value && this.district.name == value.name)
        return

      this.ward = null
      this.district = value
      this.setAddressProfile()
    },
    onChangeWard (value) {
      this.ward = value
      this.setAddressProfile()
    },
    onChangeDetail (value) {
      this.detail = value
      this.setAddressProfile()
    }
  },
  created() {
    if (!this.cityList) {
      this.$store.dispatch("loadCityList")
    }

    const fullAddress = this.formData[this.fieldName]
    if (fullAddress) {
      const elms = fullAddress.split(',')
      this.city = { name: elms[3] && elms[3].trim() }
      this.district = { name: elms[2] && elms[2].trim() }
      this.ward = { name: elms[1] && elms[1].trim() }
      this.detail = elms[0]
    }
  }
};
</script>
<style lang="scss" scoped>
.address-form {
  margin-top: 15px;
}
</style>
